import React from 'react'
import '../WhoWeAre/WhoWeAre.css'
import AboutBig from '../../Img/about-big.png';
import AboutSmall from '../../Img/about-sm.png';
import { FaArrowCircleRight, FaQuoteLeft } from "react-icons/fa";



const WhoWeAre = () => {
  return (
    <div class="section hersafe-about-section-03 section-padding-02">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    {/* <!-- About Content Start --> */}
                    <div class="about-content-03">
                    <div className="section-title">
                <h3 className="sub-title color-2">Who we are</h3>
                <h2 className="title">Empowering Digital Experiences with Innovative Solutions</h2>
            </div>

            {/* Description */}
            <p className="text">We specialize in developing cutting-edge applications designed to simplify lives, drive business success, and ensure secure, seamless digital experiences.</p>

            {/* Quote */}
            <div className="about-quote">
                <blockquote className="blockquote">
                <FaQuoteLeft />
                    <p>Our commitment is to deliver secure, user-friendly solutions that empower businesses and individuals to thrive in a digital world.</p>
                </blockquote>
            </div>
                        {/* <!-- About List Start --> */}
                        <div class="about-list-02">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="about-list-item-02">
                                        <h3 class="title"><FaArrowCircleRight />Innovation at Every Step</h3>
                                        <p>We focus on providing creative solutions that cater to evolving technological needs.</p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="about-list-item-02">
                                        <h3 class="title"><FaArrowCircleRight />Commitment to Excellence</h3>
                                        <p>Our team delivers top-quality products designed for performance, reliability, and user satisfaction.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- About List End --> */}
                    </div>
                    {/* <!-- About Content End --> */}
                </div>
                <div class="col-lg-6">
                    {/* <!-- About Image Warp Start --> */}
                    <div class="about-img-warp-3">
                        <div class="shape-1"></div>
                        <div class="about-img about-img-big">
                            <img src={AboutBig} alt=""/>
                        </div>
                        <div class="about-img about-img-sm">
                            <img src={AboutSmall} alt=""/>
                        </div>
                    </div>
                    {/* <!-- About Image Warp End --> */}
                </div>
            </div>
        </div>
    </div>
  )
}

export default WhoWeAre